import React, { useCallback } from 'react';
import { VyDialog } from '../../../../components/new-design/feedback/VyDialog';

type ApproveDraftInvoiceDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ApproveDraftInvoiceDialog: React.FC<ApproveDraftInvoiceDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const handleSubmit = useCallback(() => {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);

  return (
    <VyDialog
      open={open}
      onClose={onClose}
      label="Approve draft invoice"
      cancelButtonText="Cancel"
      ctaText="Approve"
      onSubmit={handleSubmit}
      maxWidth="sm"
    >
      <b>This invoice is still accumulating usage</b> - approving the invoice now may cause uncharged usage. Are you sure you want to approve it now?
    </VyDialog>
  );
};
